import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from "draft-js";
import { Component, memo } from "react";
import draftToHtml from "draftjs-to-html";
import { Grid, TextField } from "@mui/material";
import { FormHeading } from "../../Layouts/Heading";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import styled from "styled-components";
import "./EditorBox.css";
import { mailReset, SendNewMail } from "../../Redux/MailSlice/MaliSlice";
import { useSelector } from "react-redux";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { toast } from "react-toastify";

class MailEditor extends Component {
    state = {
        editorState: EditorState.createEmpty(),
        subject: "",
    };
    onEditorStateChange = (editorState) => {
        this.setState({ ...this.state, editorState });
    };

    handleChange = (e) => {
        this.setState({
            ...this.state,
            subject: e.target.value,
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        let { dispatch } = this.props;
        let editorHTML = draftToHtml(
            convertToRaw(this.state.editorState.getCurrentContent())
        );
        const SendMail = async () => {
            await dispatch(
                SendNewMail({ subject: this.state.subject, body: editorHTML })
            );
            await dispatch(mailReset());
        };
        SendMail();
    };

    render() {
        const { editorState } = this.state;

        return (
            <>
                {this.props?.isLoading && <LoadingAnimation />}
                {!this.props?.isLoading && (
                    <FormContainer>
                        <FormHeading> Email Message </FormHeading>
                        <form onSubmit={this.handleSubmit}>
                            <Grid container columns={12} spacing={3}>
                                <Grid item mb={1} xs={12} md={12}>
                                    <TextField
                                        fullWidth
                                        id="subject"
                                        name="subject"
                                        label="Subject"
                                        value={this.subject}
                                        onChange={this.handleChange}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    mb={1}
                                    xs={12}
                                    md={12}
                                    className="editor-box"
                                >
                                    <Editor
                                        editorState={editorState}
                                        toolbarClassName="toolbarClassName"
                                        wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName"
                                        onEditorStateChange={
                                            this.onEditorStateChange
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <PrimaryButton fullWidth type="submit">
                                Send Email
                                {this.props?.isLoading
                                    ? "loading ... "
                                    : " Update Vendor"}
                            </PrimaryButton>
                        </form>
                    </FormContainer>
                )}
            </>
        );
    }
}

const FormContainer = styled.div`
    padding: 1rem;
`;
export default memo(MailEditor);
